import type { GetAssignableDesignersForRequestResponse } from "@nlc/shared-types";

import { type DefaultError, useQuery } from "@tanstack/react-query";

import { assignableDesignersKeys } from "@/hooks/queryKeys.ts";
import apiClient from "@/lib/api/client.ts";

export function useGetAssignableDesigners(requestId?: number) {
  return useQuery<
    GetAssignableDesignersForRequestResponse,
    DefaultError,
    Array<{
      designation: string;
      id: number;
      profilePicture?: string;
      textValue: string;
    }>
  >({
    enabled: !!requestId,
    queryFn: async () =>
      await apiClient
        .url(`/requests/${requestId}/assignable-designers`)
        .get()
        .json(),
    queryKey: assignableDesignersKeys.assignableDesignersByRequestId(requestId),
    select: (data) =>
      data.designers.map(({ avatar, designation, id, name }) => ({
        designation,
        id,
        profilePicture: avatar,
        textValue: name,
      })),
  });
}
